module.exports = __webpack_public_path__ + "static/media/jp.ac0c8ef9.webp";